import ProductType from '@/const/warehouse/ProductType'

export class OrderModel {
  /**
   * 在orderList中查找匹配的商品/套餐
   * @param e
   * @param orderList
   */
  getMappedOrderItem(e, orderList) {
    if (!e || !orderList || !orderList.length) {
      return null
    }
    const { type, item, all_package_product_groups, sku, suit, make_methods } = e
    if (type === ProductType.TYPE_PACKAGE) {
      // 套餐根据任选商品判断
      const index = this.getPackageIndex(orderList, item.id, all_package_product_groups)
      return index > -1 ? orderList[index] : null
    }
    if (type === ProductType.TYPE_PRODUCT) {
      // 商品根据商品、sku和套装判断
      const index = this.getProductIndex(orderList, item, sku, suit, make_methods)
      return index > -1 ? orderList[index] : null
    }
    return null
  }

  /**
   * 获取套餐在购物车中的索引，没选过返回-1
   * @param orderList {Array} 购物车列表
   * @param packageId {String} 套餐id
   * @param allPackageProductGroups {Array} 商品列表
   */
  getPackageIndex(orderList, packageId, allPackageProductGroups) {
    if (!orderList || !allPackageProductGroups) {
      return -1
    }
    return orderList.findIndex((orderItem) => {
      if (orderItem.type !== ProductType.TYPE_PACKAGE) {
        return false
      }
      // 不是同个套餐
      if (orderItem.package_id !== packageId) {
        return false
      }
      return this.isAllPackageProductGroupsSame(
        allPackageProductGroups,
        orderItem.all_package_product_groups
      )
    })
  }

  /**
   * 比较两个套餐商品组是否一致
   */
  isAllPackageProductGroupsSame(allPackageProductGroups, oldAllPackageProductGroups) {
    // 分组数量不一致
    if (
      !allPackageProductGroups ||
      !oldAllPackageProductGroups ||
      allPackageProductGroups.length !== oldAllPackageProductGroups.length
    ) {
      return false
    }
    let isPackageProductSame = true
    oldAllPackageProductGroups.forEach((oldGroup, oldGroupIndex) => {
      const group = allPackageProductGroups[oldGroupIndex]
      const allPackageProducts = [
        ...group.fix_package_products,
        ...group.choose_any_package_products
      ]
      const oldAllPackageProducts = [
        ...oldGroup.fix_package_products,
        ...oldGroup.choose_any_package_products
      ]
      // 只要一个分组的商品不一致，不是同个套餐
      if (!this.isPackageProductsSame(allPackageProducts, oldAllPackageProducts)) {
        isPackageProductSame = false
      }
    })
    return isPackageProductSame
  }

  /**
   * 判断套餐商品是否相同
   */
  isPackageProductsSame(packageProducts, oldPackageProducts) {
    if (!packageProducts || !oldPackageProducts) {
      return false
    }
    // 商品数量不同，选中的任选商品不同
    if (packageProducts.length !== oldPackageProducts.length) {
      return false
    }
    let isSame = true
    packageProducts.forEach((packageProduct, index) => {
      if (packageProduct.id !== oldPackageProducts[index].id) {
        isSame = false
      }
      if (packageProduct.num !== oldPackageProducts[index].num) {
        isSame = false
      }
      // 套餐商品做法不同
      if (
        !this.checkIsMakeMethodsSame(
          oldPackageProducts[index].make_methods,
          packageProduct.make_methods
        )
      ) {
        isSame = false
      }
    })
    return isSame
  }

  /**
   * 获取商品在购物车中的索引，没选过返回-1
   * @param orderList {Array} 购物车列表
   * @param product {Object} 当前商品
   * @param sku {Object} 当前规格
   * @param suit {Object} 当前套装
   * @param makeMethods {Array} 当前做法
   */
  getProductIndex(orderList, product, sku, suit, makeMethods) {
    if (!orderList || !product || !sku) {
      return -1
    }
    return orderList.findIndex((orderItem) => {
      if (orderItem.type !== ProductType.TYPE_PRODUCT) {
        return false
      }
      // 不是同个商品
      if (orderItem.product_id !== product.id) {
        return false
      }
      if (product.has_suit && !suit) {
        return false
      }
      // 不是同个套装
      if (product.has_suit && orderItem.product_suit_id !== suit.id) {
        return false
      }
      // 不是同个做法
      if (!this.checkIsMakeMethodsSame(orderItem.make_methods, makeMethods)) {
        return false
      }
      return orderItem.sku_id === sku.id
    })
  }

  getCommissionStaffNumMap(commissionStaffs) {
    const commissionStaffNumMap = {}
    if (commissionStaffs) {
      commissionStaffs.forEach((commissionStaff) => {
        commissionStaffNumMap[commissionStaff.id] = commissionStaff.num
      })
    }
    return commissionStaffNumMap
  }

  /**
   * 判断做法是否相同
   * @param oldMakeMethods {Array} 原做法
   * @param makeMethods {Array} 新做法
   */
  checkIsMakeMethodsSame(oldMakeMethods, makeMethods) {
    if (!oldMakeMethods && !makeMethods) {
      return true
    }
    if (!oldMakeMethods || !makeMethods) {
      return false
    }
    let isSame = true
    makeMethods.forEach((makeMethod, index) => {
      if (makeMethod !== oldMakeMethods[index]) {
        isSame = false
      }
    })
    return isSame
  }

  /**
   * 是否需要显示套餐详情弹窗
   */
  isNeedShowPackageDetail(pkg) {
    const hasChooseAnyGroup = pkg.all_package_product_groups.some(
      (group) => group.is_choose_any && group.choose_any_package_products.length
    )
    const hasMakeMethodGroupsProduct = pkg.all_package_product_groups.some((group) => {
      const allPackageProducts = [
        ...(group.choose_any_package_products || []),
        ...group.fix_package_products
      ]
      return allPackageProducts.some(
        (packageProduct) =>
          packageProduct.product &&
          packageProduct.product.make_method_groups &&
          packageProduct.product.make_method_groups.length
      )
    })
    // 有任选组 或需要选择做法
    return hasChooseAnyGroup || hasMakeMethodGroupsProduct
  }
}
